const FALLBACK_STEPS = [
  { id: "resolve", label: "Resolving CVE identifier" },
  { id: "nvd", label: "Querying NVD JSON 2.0" },
  { id: "mitre", label: "Cross-referencing MITRE CVE Services" },
  { id: "advisory", label: "Pulling GitHub Security Advisories" },
  { id: "patches", label: "Resolving GitHub patch commits" },
  { id: "threat_intel", label: "Fetching EPSS + CISA KEV" },
  { id: "scoring", label: "Scoring real-world exploitability" },
  { id: "llm", label: "Running AI root-cause analysis" },
  { id: "pseudo_exploit", label: "Generating sanitized pseudo-exploit" },
];

const LOOK = {
  done: { icon: "✓", cls: "text-emerald-700" },
  active: { icon: "•", cls: "text-violet-700" },
  skipped: { icon: "–", cls: "text-slate-600" },
  failed: { icon: "✗", cls: "text-red-700" },
  pending: { icon: "·", cls: "text-slate-500" },
};

function StepLine({ step, state }) {
  const status = state?.status || "pending";
  const look = LOOK[status] || LOOK.pending;
  return (
    <div
      data-testid={`loader-step-${step.id}`}
      data-status={status}
      className={`${look.cls} transition-colors duration-300`}
    >
      {look.icon} {step.label}
      {status === "active" && <span className="caret">&nbsp;</span>}
      {(status === "skipped" || status === "failed") && state?.reason && (
        <span className="text-[11px] text-slate-600 ml-2">
          ({status}: {state.reason})
        </span>
      )}
    </div>
  );
}

export default function AnalysisLoader({ cveId, steps, status = {} }) {
  const list = steps && steps.length ? steps : FALLBACK_STEPS;
  return (
    <div
      data-testid="analysis-loader"
      className="panel p-7 relative overflow-hidden fade-up"
    >
      <div className="scanner-line" />
      <div className="overline mb-3 flex items-center justify-between">
        <span>Analyzing {cveId || "-"}</span>
        <span className="text-[10px] text-violet-700 normal-case tracking-normal">
          live progress
        </span>
      </div>
      <div className="font-mono text-sm space-y-1 min-h-[220px]">
        {list.map((s) => (
          <StepLine key={s.id} step={s} state={status[s.id]} />
        ))}
      </div>
    </div>
  );
}
